export const numberRegex = new RegExp(/^\d+$/);
export const decimalRegex2 = new RegExp(/^\d*\,?\d*$/);